import { create } from 'zustand';
import { generateId } from '@/utils';

export type ToastTone = 'success' | 'error' | 'info' | 'warning';

export interface ToastMessage {
  id: string;
  message: string;
  tone: ToastTone;
  duration: number;
}

interface ToastState {
  messages: ToastMessage[];
  push: (message: string, tone?: ToastTone, duration?: number) => string;
  dismiss: (id: string) => void;
  clear: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
  messages: [],
  push: (message, tone = 'info', duration = 4500) => {
    const id = generateId();
    set((state) => ({
      messages: [...state.messages.slice(-3), { id, message, tone, duration }]
    }));
    return id;
  },
  dismiss: (id) => set((state) => ({
    messages: state.messages.filter((message) => message.id !== id)
  })),
  clear: () => set({ messages: [] })
}));

const push = (message: string, tone: ToastTone, duration?: number) =>
  useToastStore.getState().push(message, tone, duration);

export const toast = {
  success: (message: string, duration?: number) => push(message, 'success', duration),
  error: (message: string, duration?: number) => push(message, 'error', duration),
  info: (message: string, duration?: number) => push(message, 'info', duration),
  warning: (message: string, duration?: number) => push(message, 'warning', duration),
  dismiss: (id: string) => useToastStore.getState().dismiss(id),
  clear: () => useToastStore.getState().clear()
};
